import {
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem
} from '@material-ui/core'
import { MoreVert } from '@material-ui/icons'
import React from 'react'

interface IFormMoreOptionsProps {
  options: {
    label: string
    icon?: any
    onClick: () => void
    disabled?: boolean
  }[]
  selectedOption?: string
}

const FormMoreOptions = ({
  options,
  selectedOption = ''
}: IFormMoreOptionsProps) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
  const [selected] = React.useState(selectedOption || '')
  const open = Boolean(anchorEl)

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  return (
    <>
      <IconButton
        onClick={handleClick}
        aria-label='more'
        aria-controls='long-menu'
        aria-haspopup='true'
        data-testid='more-options'
        style={{
          backgroundColor: 'white',
          color: 'black',
          width: 40,
          height: 40,
          marginTop: 10,
          marginBottom: 10
        }}
      >
        <MoreVert />
      </IconButton>
      <Menu
        id='form-more-options'
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        keepMounted={false}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
      >
        {options.map((option) => (
          <MenuItem
            key={option.label}
            selected={selected === option.label}
            onClick={() => {
              handleClose()
              option.onClick()
            }}
            disabled={option.disabled}
          >
            <ListItemIcon>{option.icon}</ListItemIcon>
            <ListItemText primary={option.label} />
          </MenuItem>
        ))}
      </Menu>
    </>
  )
}

export default FormMoreOptions
